<ngx-spinner type="ball-scale-multiple" sixe="large" color="#fff"></ngx-spinner>
<app-header *ngIf="service.isLoggedIn()"></app-header>
<router-outlet></router-outlet>
<app-sidebar *ngIf="service.isLoggedIn()"></app-sidebar>
<app-footer *ngIf="service.isLoggedIn()"></app-footer>

 